<template>
    <div class="d-grid">
        <button
            class="btn"
            :class="buttonClasses"
            :type="type"
            v-on="$listeners"
            @click="onSubmit"
            :disabled="submitting || disabled"
            :data-testid="dataTestid"
        >
            <img
                v-show="imageSrc"
                class="me-1"
                width="16"
                :src="getImageSrc"
                alt="icon"
            >
            <span
                v-if="submitting"
                class="spinner-border spinner-border-sm"
            />
            <span v-else>{{ label }}<sup v-if="superscript">{{ superscript }}</sup></span>
        </button>
    </div>
</template>

<script>
    import { log } from '@/utils/logger'

    export default {
        name: 'FormButton',
        props: {
            disabled: {
                type: Boolean,
                required: false,
            },
            label: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                default: 'submit',
            },
            submitting: {
                type: Boolean,
                default: false,
            },
            imageSrc: {
                type: String,
                default: null,
            },
            buttonClasses: {
                type: String,
                default: 'btn btn-primary',
            },
            eventName: {
                type: String,
                required: true,
            },
            eventProps: {
                type: Object,
                required: false,
            },
            dataTestid: {
                type: String,
                required: false,
            },
            superscript: {
                type: String,
                required: false,
            },
        },
        computed: {
            getImageSrc() {
                if (!this.imageSrc) {
                    return null
                }

                return require(`../../assets/images/${this.imageSrc}`)
            },
        },
        methods: {
            onSubmit() {
                if (this.eventName !== undefined) {
                    this.$logEvent(this.eventName, this.eventProps)
                }
                let logMessage = `click button - label: ${this.label} - event name: ${this.eventName}`
                if (this.eventProps) {
                    logMessage += `- event props: ${JSON.stringify(this.eventProps)}`
                }
                log.info('%{logMessage}', { logMessage })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/onboardingV2.scss';

    .dark .btn {
        @extend .dark-mode-btn-primary;
    }
</style>
